export default "__VITE_ASSET__CkT8lf47__"